import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import messageTemplatesRoutes from './messageTemplates/messageTemplates.routes';
import whatsappFlowsRoutes from './whatsappFlows/whatsappFlows.routes';
import whatsappCatalogsRoutes from './whatsappCatalogs/whatsappCatalogs.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as aiAgentRoutes } from './aiAgents/aiAgents.routes';
import { routes as crmRoutes } from './crm/routes';
import ordersPaymentsRoutes from './ordersPayments/ordersPayments.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...aiAgentRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...messageTemplatesRoutes.routes,
        ...whatsappFlowsRoutes.routes,
        ...whatsappCatalogsRoutes.routes,
        ...crmRoutes,
        ...ordersPaymentsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
